function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { assignInlineVars as S } from "@vanilla-extract/dynamic";
import s from "classnames";
import * as d from "react";
import { grid as b, gridTemplateColumns as c, gridTemplateColumnsAutoRepeat as G, gridTemplateRows as M, gridTemplateRowsAutoRepeat as C, gridAutoFlow as T, gridJustifyItems as v, gridAlignItems as V, gridJustifyContent as E, gridAlignContent as I, vars as a, fullColumns as J, spanColumns as N, fullRows as D, spanRows as F, columnStart as P, rowStart as h, justifySelf as k, alignSelf as q } from "./grid.css-mistica.js";
import { getPrefixedDataAttributes as z } from "./utils/dom.js";
const B = (i, e)=>{
    const t = {}, m = (r)=>typeof r == "number" ? `min(${r}px, 100%)` : r, f = (r)=>typeof r == "number" ? `${r}px` : r;
    return i && typeof i != "number" && (typeof i.minSize < "u" && (t[a.rowMinSize] = m(i.minSize)), typeof i.maxSize < "u" && (t[a.rowMaxSize] = f(i.maxSize))), e && typeof e != "number" && (typeof e.minSize < "u" && (t[a.columnMinSize] = m(e.minSize)), typeof e.maxSize < "u" && (t[a.columnMaxSize] = f(e.maxSize))), t;
}, Q = /*#__PURE__*/ d.forwardRef((param, R)=>{
    let { rows: i , columns: e , gap: t = 0 , flow: m , justifyItems: f , alignItems: r , justifyContent: n , alignContent: o , height: u , minHeight: l , children: p , as: g = "div" , dataAttributes: A  } = param;
    const [y, x] = Array.isArray(t) ? t : [
        t,
        t
    ];
    return /*#__PURE__*/ d.createElement(g, _object_spread({
        ref: R,
        className: s(b, e ? typeof e == "number" ? c[e] : G : "", i ? typeof i == "number" ? M[i] : C : "", m ? T[m] : "", f ? v[f] : "", r ? V[r] : "", n ? E[n] : "", o ? I[o] : ""),
        style: _object_spread({
            height: u,
            minHeight: l
        }, S(_object_spread({
            [a.columnGap]: y ? `${y}px` : "",
            [a.rowGap]: x ? `${x}px` : ""
        }, B(i, e))))
    }, z(A)), p);
}), U = /*#__PURE__*/ d.forwardRef((param, p)=>{
    let { rowStart: i , rowSpan: e , columnStart: t , columnSpan: m , span: f , justifySelf: r , alignSelf: n , children: o , as: u = "div" , dataAttributes: l  } = param;
    return f && (Array.isArray(f) ? (m = f[0], e = f[1]) : (m = f, e = f)), /*#__PURE__*/ d.createElement(u, _object_spread({
        ref: p,
        className: s(m ? m === "full" ? J : N[m] : "", e ? e === "full" ? D : F[e] : "", t ? P[t] : "", i ? h[i] : "", r ? k[r] : "", n ? q[n] : "")
    }, z(l)), o);
});
export { Q as Grid, U as GridItem };
